module.exports = __webpack_public_path__ + "img/Komisaris-Independent-Ahmad-Subagyo-new.a1651a0a.jpg";